<template>
  <vv-screen-wrapper>
    <div class="screen-container">
      <quiz-progress-bar />

      <template v-if="step === 'question'">
        <h1 class="question-title">{{ question }}</h1>
        <h3 class="question-subtitle">{{ $t('quiz.multipleResponse') }}</h3>

        <div class="bubbles">
          <vv-checkbox-bubble
            v-for="(checkbox, index) in choices"
            name="checkboxes"
            :key="checkbox.value"
            :value="index"
            :label="checkbox.label"
            v-model="responses"
          />
        </div>

        <div class="cta">
          <vv-button @click="goToResponse" :disabled="responses.length === 0">{{
            $t('quiz.discoverResponse')
          }}</vv-button>
        </div>
      </template>

      <multiple-response v-if="step === 'response'" @next="nextQuestion" />
    </div>
  </vv-screen-wrapper>
</template>

<script>
import { VvButton, VvCheckboxBubble, VvScreenWrapper } from '@/components/common'
import QuizProgressBar from './QuizProgressBar'
import MultipleResponse from './responses/MultipleResponse'
import { NEXT_QUESTION, RESPONSE } from '@/store/modules/quiz/types'

export default {
  name: 'MultipleBubble',
  components: { QuizProgressBar, MultipleResponse, VvButton, VvCheckboxBubble, VvScreenWrapper },
  props: {
    choices: Array,
    expectedResponse: Object,
    explanation: Object,
    question: String
  },
  data: () => ({
    responses: [],
    step: 'question'
  }),
  methods: {
    goToResponse() {
      this.$store.dispatch(RESPONSE, { choices: this.responses })
      this.step = 'response'
    },
    nextQuestion() {
      this.$store.dispatch(NEXT_QUESTION)
      this.reset()
    },
    // we reset the component because if the same type of question comes twice in a row
    // the component won't change and we'll stay on the response
    reset() {
      this.step = 'question'
      this.responses = []
    }
  }
}
</script>

<style lang="scss" scoped>
.bubbles {
  text-align: center;
}

.question-title {
  margin-bottom: 0 !important;
}
.question-subtitle {
  margin-left: 14px;
  margin-bottom: 20px;
  margin-top: 0 !important;
}
</style>
